module.exports = __webpack_public_path__ + "static/media/botones-09.1aede8af.png";